import { render, staticRenderFns } from "./PreviousGenes.vue?vue&type=template&id=1133ec36&scoped=true"
import script from "./PreviousGenes.vue?vue&type=script&lang=ts"
export * from "./PreviousGenes.vue?vue&type=script&lang=ts"
import style0 from "./PreviousGenes.vue?vue&type=style&index=0&id=1133ec36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133ec36",
  null
  
)

export default component.exports